'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Represents the spanish language
 * @type {string}
 */
var ES = exports.ES = 'es';
/**
 * Represents the english language
 * @type {string}
 */
var EN = exports.EN = 'en';


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/utils/localization/languages.js
// module id = 291
// module chunks = 35783957827783